import React, {Fragment} from "react";
import {PageHeader} from "../PageHeader";
import content from "../../content/comments.json"
import {useContent} from "../../customHooks/useContent";
import {generateRandomKey} from "../../utils/generateRandomKey";
import FD from "../../images/students/Faezeh.jpg";
import SG from "../../images/students/Saghar.jpg";
import TI from "../../images/students/Tabasom.jpg";
import GM from "../../images/students/Ghasam.jpg";

export const Comments = () => {
    const text = useContent(content);

    const images = [FD, SG, TI, GM];

    const generateComments = (comments) => {
      return comments.map((comment, index) => (
          <div className="row" key={generateRandomKey()}>
              <section className="col-12">
                  <div className="comments-portraits">
                      <div><img src={images[index]} width="240px" height="240px"
                                className="img-fluid" alt={comment.name} /></div>
                  </div>
                  <div className="comments-text">
                      <h2>{comment.name}, {comment.school}</h2>
                      <p>{comment.comment}</p>
                  </div>
              </section>
          </div>
      ));
    };


    return (
        <Fragment>
            <PageHeader subtitle={text.subtitle} imageClass="header-school-comments"/>
            <main>
                <div className="container comments">
                    {text?.comments && generateComments(text.comments)}
                </div>
            </main>
        </Fragment>
    )
};
